import { generateTechnicalContent, refineTechnicalContent } from './aiEngineService';

function getErrorMessage(error) {
  const type = error?.type;
  if (type === 'AuthenticationError') {
    return { isInternal: true, message: 'Invalid API key or authentication failed.' };
  } else if (type === 'PermissionDeniedError') {
    return { isInternal: true, message: 'Quota exceeded or authorization failed.' };
  } else if (type === 'RateLimitError') {
    return { isInternal: true, message: 'Rate limit exceeded. Please wait a moment and try again.' };
  } else if (type === 'InternalServerError') {
    return { isInternal: true, message: 'OpenAI service is currently unavailable. Please try again later.' };
  } else {
    return { isInternal: false, message: error?.message || 'An unexpected error occurred. Please try again.' };
  }
}

/**
 * Transform rough ideas into platform-optimized content using AI Engine
 * @param {string} roughIdea - The raw technical idea
 * @param {string} codeSnippet - Optional code snippet
 * @param {string} style - Writing style preference
 * @param {object} styleDetails - Custom style details
 * @param {string} additionalInstructions - Optional user customization instructions
 * @param {string} githubUrl - Optional GitHub profile URL for attribution
 * @returns {object} Transformed content for LinkedIn and Twitter
 */
export async function transformContent(roughIdea, codeSnippet, style, styleDetails, additionalInstructions = '', githubUrl = '') {
  if (!roughIdea?.trim()) {
    throw new Error('Please provide your rough idea to transform');
  }

  try {
    const result = await generateTechnicalContent(
      roughIdea,
      codeSnippet,
      style,
      styleDetails,
      ['linkedin', 'twitter'],
      additionalInstructions,
      githubUrl
    );

    return {
      linkedin: result?.linkedin || '',
      twitter: result?.twitter || ''
    };
  } catch (error) {
    console.error('Transform content error:', error);
    throw error;
  }
}

export async function refineContent(content, platform) {
  try {
    // Use new AI Engine refinement with Logic Rules
    return await refineTechnicalContent(content, platform?.toLowerCase());
  } catch (error) {
    const errorInfo = getErrorMessage(error);
    if (!errorInfo?.isInternal) {
      console.error('Error refining content:', error);
    }
    throw new Error(errorInfo.message);
  }
}